import * as React from 'react';

type Props = {
  verifiedTimestamp: string | null;
  isB2B: boolean;
};

const HiddenInputFields = ({ verifiedTimestamp, isB2B }: Props) => {
  const [retURL, setRetURL] = React.useState<string>('https://syn.is');

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      // Remove hash from URL
      setRetURL(window.location.href.split('#')[0]);
    }
  }, []);

  return (
    <>
      {/* Salesforce uses the element name to map the fields, the id can be changed/removed.
          Fixed values from Salesforce */}
      <input
        type="hidden"
        name="captcha_settings"
        // VodafoneWeb is the name of the ReCaptcha project within the Vodafone Google account
        value={`{"keyname":"VodafoneWeb","fallback":"false","orgId":"${process.env.NEXT_PUBLIC_SF_ORG_ID}","ts":"${verifiedTimestamp}"}`}
      />
      <input type="hidden" id="oid" name="oid" value={process.env.NEXT_PUBLIC_SF_ORG_ID} />
      <input
        type="hidden"
        id="recordType"
        name="recordType"
        value={isB2B ? process.env.NEXT_PUBLIC_SF_RECORD_TYPE_B2B : process.env.NEXT_PUBLIC_SF_RECORD_TYPE_B2C}
      />
      <input type="hidden" name="retURL" value={`${retURL}?komdu-i-vidskipti=true`} />
      <input type="hidden" id="lead_source" name="lead_source" value="Website" />
      {/* Value is always Consumer for B2C */}
      {!isB2B && <input type="hidden" id="company" name="company" value="Consumer" />}
      {/* Fixed value for B2B. We use a visible description field for B2C. */}
      {isB2B && <input type="hidden" id="description" name="description" value="Óskar eftir því að koma í viðskipti" />}
    </>
  );
};
export default HiddenInputFields;
